import React from 'react';
import { colors } from 'styleguide';

import { IconProps } from './types';

const Tick = ({ size = 20, color = colors('neutral', 3) }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.92001 9.9144L9.37714 12.5429L12.9677 8.3898"
      stroke={color}
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default Tick;
